import iconDark from 'assets/images/studio/data-source/kobaiAPI.dark.svg';
import iconLight from 'assets/images/studio/data-source/kobaiAPI.light.svg';
import cn from 'utils/cn';

interface KobaiAPIIconProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  style?: React.CSSProperties;
  variant?: 'light' | 'dark';
}

const KobaiAPIIcon = ({ variant = 'dark', ...rest }: KobaiAPIIconProps) => (
  <img
    {...rest}
    alt="kobai api icon"
    data-testid={`kobai-api-icon-${variant}`}
    src={variant === 'light' ? iconLight : iconDark}
    className={cn('tw:h-[16px] tw:w-[16px]', rest?.className)}
  />
);

export default KobaiAPIIcon;
